import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=01d261dc&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=01d261dc&prod&scoped=true&lang=scss"
import style1 from "./ResourceDetail.vue?vue&type=style&index=1&id=01d261dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d261dc",
  null
  
)

export default component.exports